import { useTranslation } from 'react-i18next';
import { FlexCol } from '@/UI/styles';
import { useSettingsStore } from '@/state/settings.state';
import useWorkspacesStore from '@/state/workspaces.state';
import { I18N_KEYS } from '@/language/keys';
import { TextLgMd, TextSmMd, TextSmRg } from '@/UI/AppTypography/AppTypography';
import { color } from '@/colors';
import { ModelTable } from './ModelsTable/ModelsTable';

export const ModelManagement = () => {
  const { t } = useTranslation();
  const workspaceModels = useSettingsStore((state) => state.workspaceModels);
  const workspaceModelsLoadingState = useSettingsStore((state) => state.workspaceModelsLoadingState);
  const shouldBlockUnverifiedModels = useWorkspacesStore((state) =>
    Boolean(state.activeWorkspace.preferences?.shouldBlockUnverifiedModels),
  );

  const isLoading = workspaceModelsLoadingState === 'loading';

  return (
    <FlexCol sx={{ flex: 1, height: '100%', gap: 4, pb: 3 }}>
      <FlexCol sx={{ gap: 2, pt: '1.5px' }}>
        <TextLgMd text={t(I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TITLE)} />
        <FlexCol sx={{ gap: 0.5 }}>
          <TextSmMd text={t(I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.SUBTITLE_VERIFIED)} color={color.White80_T} />
          <TextSmRg text={t(I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TEXT_VERIFIED)} color={color.White64_T} />
        </FlexCol>
        {!shouldBlockUnverifiedModels && (
          <FlexCol sx={{ gap: 0.5 }}>
            <TextSmMd text={t(I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.SUBTITLE_UNVERIFIED)} color={color.White80_T} />
            <TextSmRg text={t(I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TEXT_UNVERIFIED)} color={color.White64_T} />
          </FlexCol>
        )}
      </FlexCol>
      <ModelTable models={workspaceModels} isLoading={isLoading} />
    </FlexCol>
  );
};
